export const INPUT_TYPES = {
  SEND_MONEY: 'SEND_MONEY',
  DEPOSIT_MONEY: 'DEPOSIT_MONEY',
  WIRE_MONEY: 'WIRE_MONEY'
};
